<template class="pageUser">
  <div class="page-user">
    <div class="row justify-content-center mt-5">
      <div class="col-12 col-md-10 col-lg-6">
      </div>
    </div>

    <b-form @submit.prevent="sendData()">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-6">
          <b-card class="card-add custom">
            <template slot="header">
              <h2>{{$t('Edycja tłumaczenia')}}</h2>
            </template>
            <b-card-text>
              <div class="row">
                <div class="col-12">
                  <label for="name"><span>* </span>{{$t('Klucz')}}:</label>
                  <b-form-input id="name" size="lg"
                                :placeholder="$t('Eg') + `: ` +  $t('Polski')"
                                disabled
                                v-model="element.key"
                                class="custom">
                  </b-form-input>
                </div>
                <div class="col-12">
                  <label for="firstLang"><span>* </span>{{firstLangTitle}}:</label>
                  <b-form-input id="firstLang" size="lg"
                                v-model="element.firstLang"
                                name="element.firstLang"
                                key="element.firstLang"
                                :state="validateState('element.firstLang')"
                                v-validate="{'required':true}"
                                class="custom">
                  </b-form-input>
                </div>
                <div class="col-12">
                  <label for="secondLang"><span>* </span>{{secondLangTitle}}:</label>
                  <b-form-input id="secondLang" size="lg"
                                v-model="element.secondLang"
                                name="element.secondLang"
                                key="element.secondLang"
                                :state="validateState('element.secondLang')"
                                v-validate="{'required':true}"
                                class="custom">
                  </b-form-input>
                </div>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-6 ">
          <div class="row justify-content-between">
            <div class="col-4 d-flex">
              <b-link class="custom btn-link align-self-center ml-3"
                      @click="showConfirmCancelModal()"
              >{{$t('Anuluj')}}
              </b-link>

            </div>
            <div class="col-4 pl-2">
              <b-button type="submit"
                        variant="primary"
                        class="custom"
                        block>{{$t('Zapisz')}}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <confirmCancelModal></confirmCancelModal>
  </div>
</template>

<script>
import confirmCancelModal from '@/components/Modals/ConfirmCancelModal'
import EventBus from '@/event-bus.js'

export default {
  name: 'adminLanguage',
  data () {
    return {
      returnPath: 'admin.translations',
      element: {
        name: null,
        active: true,
        main: false,
        code: null
      },
      firstLangTitle: null,
      secondLangTitle: null
    }
  },
  components: { confirmCancelModal },
  methods: {
    sendData () {
      this.$validator.validateScopes().then((result) => {
        if (result) {
          this.$store.dispatch('sendTranslationData', {
            data: this.element,
            params: this.queryParams
          }).then(resp => {
            this.$router.push({ name: this.returnPath })
          })
        }
      })
    },
    showConfirmCancelModal () {
      EventBus.$emit(`SHOW_CONFIRM_CANCEL_MODAL`, { returnPath: this.returnPath })
    },
    validateState (ref) {
      if (
        this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    }
  },
  computed: {
    elementId () {
      return this.$route.params.id
    },
    queryParams () {
      return this.$route.query
    }
  },
  watch: {},
  created () {
    if (this.elementId !== undefined && this.elementId !== null && this.elementId !== '' &&
                this.queryParams !== undefined && this.queryParams !== null) {
      if (this.queryParams.firstLang === this.queryParams.secondLang) {
        this.$router.push({ name: this.returnPath })
      }

      this.$store.dispatch('getTranslation', {
        id: this.elementId,
        params: this.queryParams
      }).then(response => {
        if (response[0] === undefined) {
          this.$router.push({ name: this.returnPath })
        }
        this.element = response[0]
        let firstLang = this.$store.getters.getLanguagePerId(this.queryParams.firstLang)
        if (firstLang === undefined || firstLang === null) {
          this.firstLangTitle = this.$t('Język 1')
        } else {
          this.firstLangTitle = firstLang.code
        }
        let secondLang = this.$store.getters.getLanguagePerId(this.queryParams.secondLang)
        if (secondLang === undefined || secondLang === null) {
          this.secondLangTitle = this.$t('Język 2')
        } else {
          this.secondLangTitle = secondLang.code
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
